/**
 * @readonly
 * @typedef {string} incidentStatus
 * @enum {incidentStatus}
 */
export const IncidentStatus = {
    COMPLETED: 'completed',
    IDENTIFIED: 'identified',
    IN_PROGRESS: 'in_progress',
    INVESTIGATING: 'investigating',
    MONITORING: 'monitoring',
    RESOLVED: 'resolved',
    SCHEDULED: 'scheduled',
    VERIFYING: 'verifying'
}
